import { scorePhone } from '@/assets/images/offer';
import { useTrackOnboardingCompleted } from '@/lib/tracking';
import { VoltAppBanner } from '../../components/VoltAppBanner';
import styles from './PreliminaryNoOfferPage.module.scss';

/**
 * No preliminary offer on the BC score (and everything else): the app shows
 * how to grow it. Income rejections have the refinance page, and no BC score
 * at all the no-score page.
 */
export function PreliminaryNoOfferPage() {
  useTrackOnboardingCompleted();

  return (
    <div className={styles.root}>
      <div className={styles.header}>
        <h1 className={styles.title}>Scorul tău e prea mic 😔</h1>
        <p className={styles.description}>
          Scorul tău FICO este momentan prea mic pentru o ofertă de credit.
        </p>
      </div>
      <div>
        <img
          src={scorePhone}
          alt=""
          width={343}
          height={254}
          className={styles.phone}
        />
        <VoltAppBanner
          title="Află cum îți crești scorul în Volt"
          trackingId="preliminary_no_offer_download_volt"
        />
      </div>
    </div>
  );
}

export default PreliminaryNoOfferPage;
